import {
  type GetDuplicateExpensesIDsQueryVariables,
  useGetDuplicateExpensesIDsLazyQuery,
} from "@src/__generated__/graphql";
import { useDebounce } from "react-use";

export const useFetchDuplicateExpenses = (
  args: GetDuplicateExpensesIDsQueryVariables,
): string[] => {
  const [fetch, { data }] = useGetDuplicateExpensesIDsLazyQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  useDebounce(
    () => {
      !!args.variableSymbol && fetch({ variables: args });
    },
    600,
    [
      args.contractorId,
      args.variableSymbol,
      args.excludeExpenseId,
      args.documentNumber,
    ],
  );

  return data?.getDuplicateExpensesIDs || [];
};
